import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import {
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Title,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { IconCheck, IconTimeDuration15 } from "@tabler/icons-react";

const SyncItemTMĐT = () => {
  const [timeSync, setTimeSync] = useState({
    startDate: "",
    endDate: "",
  });

  const [visible, { toggle, open, close }] = useDisclosure(false);

  const handleSyncItemEcom = async () => {
    open();
    try {
      let url = `/api/v1/Ecommerce/sync-item?`;

      if (timeSync.startDate && timeSync.startDate.length > 0) {
        url += `FromLastDate=${new Date(
          new Date(timeSync.startDate).getTime() + 7 * 3600 * 1000
        ).toISOString()}&`;
      }

      if (timeSync.endDate && timeSync.endDate.length > 0) {
        url += `ToLastDate=${new Date(
          new Date(timeSync.endDate).getTime() + 7 * 3600 * 1000
        ).toISOString()}&`;
      }

      const res = await repositoryPos.get<MessageResponse<any>>(url);

      if (res && res.success) {
        NotificationExtension.Success("Đồng bộ vật tư TMĐT thành công !");
        setTimeout(() => {
          modals.closeAll();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box mt={10}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <Grid w={"100%"}>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <DateTimePicker
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="md"
            label="Ngày bắt đầu"
            placeholder="Từ ngày"
            locale="vi"
            value={
              timeSync?.startDate && timeSync?.startDate?.length > 0
                ? new Date(timeSync?.startDate)
                : null
            }
            maxDate={
              timeSync?.endDate && timeSync?.endDate?.length > 0
                ? new Date(timeSync?.endDate)
                : undefined
            }
            onChange={(e) => {
              setTimeSync((prev) => ({
                ...prev,
                startDate: e ? new Date(e)?.toISOString() : "",
              }));
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <DateTimePicker
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="md"
            label="Ngày kết thúc"
            placeholder="Đến ngày"
            locale="vi"
            value={
              timeSync?.endDate && timeSync?.endDate?.length > 0
                ? new Date(timeSync?.endDate)
                : null
            }
            minDate={
              timeSync?.startDate && timeSync?.startDate?.length > 0
                ? new Date(timeSync?.startDate)
                : undefined
            }
            onChange={(e) => {
              setTimeSync((prev) => ({
                ...prev,
                endDate: e ? new Date(e)?.toISOString() : "",
              }));
            }}
            clearable
          />
        </Grid.Col>
      </Grid>
      <Group justify="flex-end">
        <Button
          leftSection={<IconCheck />}
          variant="filled"
          color="blue"
          mt={10}
          disabled={
            (!timeSync.startDate || timeSync?.startDate?.length === 0) &&
            (!timeSync.endDate || timeSync?.endDate?.length === 0)
          }
          onClick={() => handleSyncItemEcom()}
        >
          Xác nhận
        </Button>
      </Group>
    </Box>
  );
};

export default SyncItemTMĐT;
